import { memo } from 'react'
import { Typography, Button } from '@material-ui/core'
import { ButtonProps as DialogAction } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import {
  Container,
  DialogTitle,
  Image,
  DialogContent,
  DialogText,
  ButtonGroup,
  CloseButton,
} from './ErrorDialog.style'
import Modal from 'shared/components/Modal'

const ID_PREFIX = 'error-modal'

export interface ErrorDialogProps {
  isOpen: boolean
  title: string
  image: string
  text: string
  dialogActions: DialogAction[]
  onClose?: () => void
}

const ErrorDialog = ({
  isOpen,
  title,
  image,
  text,
  onClose,
  dialogActions,
}: ErrorDialogProps) => {
  return (
    <Modal open={isOpen} disableBackdropClick onClose={onClose}>
      <Container>
        {onClose && (
          <CloseButton onClick={onClose} id={`${ID_PREFIX}-close-btn`}>
            <CloseIcon />
          </CloseButton>
        )}
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Image src={image} />
          <DialogText>
            <Typography>{text}</Typography>
          </DialogText>
          <ButtonGroup>
            {dialogActions.map(action => (
              <Button key={action.children as string} {...action} />
            ))}
          </ButtonGroup>
        </DialogContent>
      </Container>
    </Modal>
  )
}

export default memo(ErrorDialog)
